/**
 * Converts a camelCase string to a human-readable format.
 * @param {string} str - The camelCase string to convert.
 * @returns {string} The converted string in a human-readable format.
 */
export function prettifyCamelCase(str: string): string {
  let output = '';
  const len = str.length;
  let char: string;

  for (let i = 0; i < len; i++) {
    char = str.charAt(i);

    if (!i) {
      output += char.toUpperCase();
    } else if (char !== char.toLowerCase() && char === char.toUpperCase()) {
      output += ' ' + char;
    } else if (char === '-' || char === '_') {
      output += ' ';
    } else {
      output += char;
    }
  }

  return output;
}
